module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "trending-comp trending-videos"
  }, [(_vm.title) ? _c('div', {
    staticClass: "top-bar"
  }, [_c('h2', {
    staticClass: "bar-title"
  }, [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), _c('item-tab', {
    staticClass: "mb-3",
    attrs: {
      "mode": "grid",
      "minHeight": "180"
    }
  }, [_c('template', {
    slot: "itemTabs"
  }, _vm._l((_vm.videoFeed), function(feed, index) {
    return _c('span', {
      key: index,
      class: ['tab-holder px-0 flex', _vm.classAttr]
    }, [_c('video-box', {
      attrs: {
        "hoverOverlay": false,
        "item": feed,
        "hideUser": "",
        "hideFreeTag": "",
        "showFullOverlay": _vm.showFullOverlay,
        "coverOnly": _vm.coverOnly,
        "coverRadius": _vm.coverRadius
      }
    })], 1)
  }))], 2), _vm._v(" "), (!_vm.hideCta) ? _c('div', {
    staticClass: "cta"
  }, [_c('v-btn', {
    staticClass: "cta-btn",
    attrs: {
      "block": "",
      "outline": ""
    }
  }, [_c('strong', [_vm._v(" View all videos ")])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f3dc97b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/components/trending/videos.vue
// module id = 1739
// module chunks = 180